// extracted by mini-css-extract-plugin
export default {"advertCardHeader":"c-a_iB","advertCardHeader__actions":"c-a_iC","advertCardHeader__bottomLabel":"c-a_iE"};